import Divider from './src/divider';

Divider.install = function(Vue) {
  Vue.component(Divider.name, Divider);
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/divider/index.js